var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.6 49.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8,25.73A12.87,12.87,0,1,1,34.67,12.87,12.88,12.88,0,0,1,21.8,25.73Zm0-23.23A10.37,10.37,0,1,0,32.16,12.87,10.38,10.38,0,0,0,21.8,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6,49.91H0V48.66a21.8,21.8,0,0,1,43.6,0ZM2.55,47.4h38.5a19.3,19.3,0,0,0-38.5,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.a079e8eff3e2cb9384bf08d855fa521f.svg";
export { ForwardRef as ReactComponent };